import { API } from '../_utils/API'

const getAllProperties = params => {

    var str = "";
    for (var key in params) {
        if (str !== "") {
            str += "&";
        }
        str += key + "=" + encodeURIComponent(params[key]);
    }
    // https://api.airdna.co/v1/market/property_list?access_token=MTkzMjI3|a09285e30bfe4e7e9fa97980fc19552b&city_id=91890&start_month=9&start_year=2016&number_of_months=36&currency=native&show_regions=true

    return API.get(`/market/property_list?${str}`)
        .then(response => {
            return response
        })
        .catch(error => {
            // Error
            console.error(error);
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                return error.response.data
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request)
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message)
            }
            return error
        })
}

export const marketService = {
    getAllProperties
}